module.exports = __webpack_public_path__ + "img/GAME_SEAWORLD.48c9cd94.jpg";